(function() {
  'use strict';

  angular
    .module('specsguardApp')
    .directive('sgPasswordStrength', sgPasswordStrength);

  function sgPasswordStrength () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/components/sg-password-strength/sg-password-strength.tmpl.html',
      controller: 'sgPasswordStrengthCtrl',
      controllerAs: '$sgPasswordStrengthCtrl',
    };
  }

})();
